export const TOUR_RATING_DEFAULT = {

  score: 8.2,

  reviewCount: 18,

  labelKey: "tour.rating_very_good",

} as const



const TOUR_RATING_SCORE_MIN = 8.0

const TOUR_RATING_SCORE_STEPS = 7

const TOUR_REVIEW_COUNT_MIN = 12

const TOUR_REVIEW_COUNT_SPAN = 89 - TOUR_REVIEW_COUNT_MIN + 1



export const TOUR_SOCIAL_PROOF_KEYS = [

  "tour.social_proof_15_24h",

  "tour.social_proof_8_8h",

  "tour.social_proof_10_8h",

  "tour.social_proof_20_24h",

  "tour.social_proof_6_4h",

  "tour.social_proof_15_24h_alt",

] as const



const hashTourId = (tourId: string): number =>

  [...tourId].reduce((sum, char) => sum + char.charCodeAt(0), 0)



export const getDeterministicTourDisplayRating = (tourId: string) => {

  if (!tourId) {

    return {

      score: TOUR_RATING_DEFAULT.score,

      reviewCount: TOUR_RATING_DEFAULT.reviewCount,

    }

  }



  const hash = hashTourId(tourId)

  const scoreIndex = hash % TOUR_RATING_SCORE_STEPS

  const score =

    Math.round((TOUR_RATING_SCORE_MIN + scoreIndex * 0.1) * 10) / 10

  const reviewCount =

    TOUR_REVIEW_COUNT_MIN +

    ((hash * 31 + tourId.length) % TOUR_REVIEW_COUNT_SPAN)



  return { score, reviewCount }

}



export const getTourRatingStatus = (rate: number): string => {

  if (rate > 8) {

    return "tour.rating_very_good"

  }

  if (rate > 6) {

    return "common.great"

  }

  return "tour.rating_good"

}



export const getTourSocialProofKey = (tourId: string) => {

  const index = hashTourId(tourId)

  return TOUR_SOCIAL_PROOF_KEYS[index % TOUR_SOCIAL_PROOF_KEYS.length]

}



export const resolveTourRating = (tourId: string) => {

  const { score, reviewCount } = getDeterministicTourDisplayRating(tourId)

  const labelKey = getTourRatingStatus(score)



  return { score, reviewCount, labelKey }

}


